$('.subscription-widget-wrapper .subscribe_now_check').on('click', function(){
    if(!$(this).hasClass("checked_option")){
        $('.subscribe_now_check').removeClass("checked_option");
        $('.subscription-widget label').removeClass("active");

        if (this.value == 'as_subscription') {
            $('product-form .product-form__actions .form__input-wrapper quantity-input').css("display", "none");
            $('product-form .product-form__actions button.add-to-cart').css("display", "none");
            // $('product-form .product-form__actions .pdp_atc_btn_wrapper').append("<p class='add_subscription_to_cart'><span class='subscription_total_price'></span>Add to cart</p>");
            $('product-form .product-form__actions .pdp_atc_btn_wrapper quantity-input').after("<p class='add_subscription_to_cart'>Add to cart</p>");
            $(".add_subscription_to_cart .subscription_total_price").html($(".subscription_price_wrapper .sp_after_discount").html() + " - ");
        }else{
            $('product-form .product-form__actions button.add-to-cart').css("display", "block");
            $('product-form .product-form__actions .form__input-wrapper quantity-input').css("display", "flex");
            $('.add_subscription_to_cart').remove();
        }
        $(this).addClass("checked_option");
        $(this).closest("label").addClass("active");
    }
})

// Getting Selling plan and discount %
let discount_value = 0;
let selling_plan = document.querySelector('.subscription-widget-wrapper').getAttribute('data-selling-plan');
let subscription_discount = document.querySelector('.subscription-widget-wrapper').getAttribute('data-subscription-discount');

setInterval(function () {
    let spAfter = document.querySelector(".sp_after_discount");
    let spBefore = document.querySelector(".sp_before_discount");

    if (spAfter && spBefore) {
        if (spAfter.innerHTML.trim() === "" && spBefore.innerHTML.trim() === "") {
            let selectedRadio = document.querySelector(".variant-picker__option input[type='radio']:checked");
            if (selectedRadio) {
                let packOption = selectedRadio.closest(".variant-picker__option");
                if (packOption) {
                    let salePriceEl = packOption.querySelector(".packPrice .f-price-item--sale-option");
                    let regularPriceEl = packOption.querySelector(".packPrice .f-price-item--regular-option");
                    let salePrice = (salePriceEl && salePriceEl.innerHTML.trim() !== "") ? salePriceEl.innerHTML.trim() : "";
                    let regularPrice = (regularPriceEl && regularPriceEl.innerHTML.trim() !== "") ? regularPriceEl.innerHTML.trim() : "";

                    if (salePrice !== "" && regularPrice !== "") { 
                        let variant_selling_price = salePrice.trim().replace(/\$/g, "").replace(/,/g, "");
                        if( subscription_discount == 10 ){
                            discount_value = 0.1
                        }else{
                            discount_value = 0.05
                        }
                        let discounted_price = variant_selling_price * discount_value;
                        let discounted_selling_price = variant_selling_price - discounted_price;

                        spBefore.innerHTML = salePrice;
                        spAfter.innerHTML = "$"+discounted_selling_price.toFixed(2);
                    }
                }
            }
        }
    }
}, 100);

$('.sf-prod__info-wrapper').on('click', '.add_subscription_to_cart', function(){
    let bottle_type_qty = $('variant-button').attr('data-selected-bottle');
    let sp_var_id = $('variant-picker variant-button').attr('data-sp-id');
    let qty = $('variant-picker variant-button').attr('data-selected-bottle');

    if( sp_var_id && qty > 0 ){
    
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: sp_var_id,
                quantity: qty,
                selling_plan: selling_plan,
                properties: {
                    "Pack of ": bottle_type_qty
                }
            })
        })
        .then(res => res.json())
        .then(data => console.log("Added:", data))
        .catch(err => console.error(err));
    }


})